import React from 'react'

export const directions = {
  UP: 'up',
  DOWN: 'down',
}

const SectionDivider = ({ direction = directions.UP }) => {
  const clipPathUp =
    '[clip-path:polygon(0_12px,calc(50%-12px)_12px,50%_0,calc(50%+12px)_12px,100%_12px,100%_100%,0_100%)]'
  const clipPathDown =
    '[clip-path:polygon(0_0,100%_0,100%_calc(100%-12px),calc(50%+12px)_calc(100%-12px),50%_100%,calc(50%-12px)_calc(100%-12px),calc(50%-12px)_calc(100%-12px),0_calc(100%-12px))]'

  return (
    <div className="relative h-4 w-full">
      <span
        className={`absolute inset-0 bg-ac-dark-gold ${
          direction === directions.UP ? clipPathUp : clipPathDown
        }`}
      />
    </div>
  )
}

export default SectionDivider
